/* eslint-disable import/prefer-default-export */
export { default as mapCapCoin } from './mapCapCoin';



// WEBPACK FOOTER //
// ./src/utils/index.js